exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctt-modal.fixed{position:fixed}", ""]);

// exports
